import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'bt-list-modal',
	standalone: true,
	templateUrl: './list-modal.component.html',
	styleUrl: './list-modal.component.scss',
	imports: [MatDialogModule]
})
export class ListModalComponent {
	readonly #dialogRef = inject(MatDialogRef<ListModalComponent>);
	readonly data = inject<{ title: string; list: string[] }>(MAT_DIALOG_DATA);

	readonly title = this.data.title ?? '';
	readonly list = this.data.list ?? [];

	close(): void {
		this.#dialogRef.close();
	}

	copyToClipboard(item: string): void {
		navigator.clipboard.writeText(item).then(
			() => {
				console.log('Copied to clipboard:', item);
			},
			(err) => {
				console.error('Failed to copy to clipboard:', err);
			}
		);
	}
}
